import React from 'react';
import { combineReducers, createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import { takeLatest, put, call, select } from 'redux-saga/effects';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var actionTypes$2 = {
  EMAIL_COLLECTION_RESPONSE: "EMAIL_COLLECTION_RESPONSE",
  EMAIL_COLLECTION_STATUS: "EMAIL_COLLECTION_STATUS",
  EMAIL_COLLECTION_SUBMISSION: "EMAIL_COLLECTION_SUBMISSION"
};

var submissionStatus$1 = {
  open: "open",
  sent: "sent",
  received: "received",
  error: "error",
  success: "success",
  complete: "complete"
};
var storeRoot$3 = "emailCollection";

var emailCollectionConstants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  submissionStatus: submissionStatus$1,
  storeRoot: storeRoot$3
});

var initialFormData$1 = {
  submission: {
    emailAddress: ""
  },
  response: null,
  status: submissionStatus$1.open,
  errors: null
};

var emailCollectionFormReducers$1 = function emailCollectionFormReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialFormData$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes$2.EMAIL_COLLECTION_SUBMISSION:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        submission: action.payload
      });

    case actionTypes$2.EMAIL_COLLECTION_RESPONSE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        response: action.payload
      });

    case actionTypes$2.EMAIL_COLLECTION_STATUS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        status: action.payload
      });

    default:
      return state;
  }
};

var LEAD_GENERATION_CLEAR = "LEAD_GENERATION_CLEAR";
var LEAD_GENERATION_RESPONSE = "LEAD_GENERATION_RESPONSE";
var LEAD_GENERATION_STATUS = "LEAD_GENERATION_STATUS";
var LEAD_GENERATION_SUBMISSION = "LEAD_GENERATION_SUBMISSION";
var LEAD_GENERATION_SET_APPOINTMENT = "LEAD_GENERATION_SET_APPOINTMENT";
var LEAD_GENERATION_SET_SCHEDULE = "LEAD_GENERATION_SET_SCHEDULE";
var LEAD_GENERATION_SET_COMPLETION_REDIRECT = "LEAD_GENERATION_SET_COMPLETION_REDIRECT"; // Deprecate Below When Direct Eloqua Communication is no longer needed

var ELOQUA_PREPOP_REQUEST = "ELOQUA_PREPOP_REQUEST";
var ELOQUA_PREPOP_SUCCESS = "ELOQUA_PREPOP_SUCCESS";
var ELOQUA_PREPOP_FAILURE = "ELOQUA_PREPOP_FAILURE";
var PROCESS_HARDCODED_FORM_DATA = "PROCESS_HARDCODED_FORM_DATA";
var FORM_FIELD_CHANGE = "FORM_FIELD_CHANGE";
var PROCESS_FIELD_ERROR = "PROCESS_FIELD_ERROR";
var VERIFY_FORM_VALIDITY = "VERIFY_FORM_VALIDITY";
var PREPARE_AUTO_SUBMIT_FORM = "PREPARE_AUTO_SUBMIT_FORM";
var PREPARE_USER_SUBMIT_FORM = "PREPARE_USER_SUBMIT_FORM";
var USER_SUBMIT_FORM = "USER_SUBMIT_FORM";
var AUTO_SUBMIT_FORM = "AUTO_SUBMIT_FORM";
var GEOIP_REQUEST = "GEOIP_REQUEST";
var GEOIP_SUCCESS = "GEOIP_SUCCESS";
var GEOIP_FAILURE = "GEOIP_FAILURE";
var GEOIP_FALLBACK = "GEOIP_FALLBACK";
var PARSE_QUERY_PARAMS = "PARSE_QUERY_PARAMS";

var storeRoot$2 = "leadGeneration";
var submissionStatus = {
  open: "open",
  sent: "sent",
  received: "received",
  error: "error",
  success: "success",
  complete: "complete"
}; // Deprecate Below When Direct Eloqua Communication is no longer needed

var formConditions = {
  ".com": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "US Business Resources Pricing Form",
        CampaignID: "7010W000002b4xX",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "US Business Webpage Pricing Form",
        CampaignID: "7010W0000023pND",
        subSector1: ""
      },
      consulting: {
        CampaignID: "7010W0000027qbj",
        importSourceMostRecent1: "US CORP Consulting Pricing Form",
        subSector1: "Professional Services",
        omniformname: "corporate"
      },
      manufacturing: {
        CampaignID: "7010W0000027qbe",
        importSourceMostRecent1: "US CORP Manufacturing Pricing Form",
        subSector1: "Manufacturing",
        omniformname: "corporate"
      },
      foodservice: {
        CampaignID: "7010W0000027qbZ",
        importSourceMostRecent1: "US CORP Foodservice Pricing Form",
        subSector1: "Food and Beverage",
        omniformname: "corporate"
      },
      hospitality: {
        CampaignID: "7010W0000027qbU",
        importSourceMostRecent1: "US CORP Hospitality Pricing Form",
        subSector1: "Hospitality",
        omniformname: "corporate"
      },
      construction: {
        CampaignID: "7010W0000027qbK",
        importSourceMostRecent1: "US CORP Construction Pricing Form",
        subSector1: "Construction",
        omniformname: "corporate"
      },
      healthcare: {
        CampaignID: "7010W0000027qbF",
        importSourceMostRecent1: "US CORP Healthcare Pricing Form",
        subSector1: "Healthcare",
        omniformname: "corporate"
      },
      retail: {
        CampaignID: "7010W0000027qbP",
        importSourceMostRecent1: "US CORP Retail Pricing Form",
        subSector1: "Retail",
        omniformname: "corporate"
      },
      government: {
        CampaignID: "7010W000002OLajQAG",
        importSourceMostRecent1: "US CORP Government Pricing Form",
        subSector1: "Government",
        omniformname: "corporate"
      }
    },
    k12: {
      resources: {
        omniformname: "k12",
        importSourceMostRecent1: "US K12 Resources Pricing Form",
        CampaignID: "7010W000002b4xS",
        subSector1: ""
      },
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "US K12 Webpage Pricing Form",
        CampaignID: "7010W0000023pNIQAY",
        subSector1: ""
      },
      solutions: {
        omniformname: "k12",
        CampaignID: "7010W0000023pNIQAY",
        importSourceMostRecent1: "US K12 Solutions Pricing Form",
        subSector1: ""
      }
    },
    pubsec: {
      webpage: {
        omniformname: "pubsec",
        importSourceMostRecent1: "US Public Sector Webpage Pricing Form",
        CampaignID: "7010W000001v8Q9",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "US Higher Education Webpage Pricing Form",
        CampaignID: "7010W000001v8Q4",
        subSector1: ""
      }
    }
  },
  ".co.uk": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "UK Business Resources Pricing Form",
        CampaignID: "7010W0000023r4p",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "UK Business Webpage Pricing Form",
        CampaignID: "7010W0000023pNN",
        subSector1: ""
      },
      consulting: {
        CampaignID: "7010W0000027xcH",
        importSourceMostRecent1: "UK Consulting Pricing Form",
        subSector1: "Professional Services",
        omniformname: "corporate"
      },
      financial: {
        CampaignID: "7010W0000027xcM",
        importSourceMostRecent1: "UK Financial Services Pricing Form",
        subSector1: "Financial Services",
        omniformname: "corporate"
      },
      logistics: {
        CampaignID: "7010W0000027xcC",
        importSourceMostRecent1: "UK Logistics Pricing Form",
        subSector1: "Transport & Logistics",
        omniformname: "corporate"
      },
      manufacturing: {
        CampaignID: "7010W0000027xc7",
        importSourceMostRecent1: "UK Manufacturing Pricing Form",
        subSector1: "Manufacturing",
        omniformname: "corporate"
      },
      pharmaceutical: {
        CampaignID: "7010W0000027xbx",
        importSourceMostRecent1: "UK Pharmaceutical Pricing Form",
        subSector1: "Pharmaceutical",
        omniformname: "corporate"
      },
      retail: {
        CampaignID: "7010W0000027xc2",
        importSourceMostRecent1: "UK Retail Pricing Form",
        subSector1: "Retail",
        omniformname: "corporate"
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "UK K12 Webpage Pricing Form",
        CampaignID: "7010W0000023pNS",
        subSector1: ""
      }
    }
  },
  ".de": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "DE Business Resources Pricing Form",
        CampaignID: "7010W0000023r4u",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "DE Business Webpage Pricing Form",
        CampaignID: "7010W0000023pNc",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "DE EDU Webpage Pricing Form",
        CampaignID: "7010W0000023pNX",
        subSector1: ""
      }
    }
  },
  ".espanol": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "LatAm Business Resources Pricing Form",
        CampaignID: "7010W000001zGtE",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "LatAm Business Webpage Pricing Form",
        CampaignID: "7010W0000023rkq",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "LatAm K12 Webpage Pricing Form",
        CampaignID: "7010W0000023rkv",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "LatAm HED Webpage Pricing Form",
        CampaignID: "7010W000002bHuz",
        subSector1: ""
      }
    }
  },
  ".es": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "ES Business Resources Pricing Form",
        CampaignID: "7010W000001zGtO",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "ES Business Webpage Pricing Form",
        CampaignID: "7010W0000023sL5",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "ES EDU Webpage Pricing Form",
        CampaignID: "7010W0000023sL0",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "ES HED Webpage Pricing Form",
        CampaignID: "7010W000002bHv9",
        subSector1: ""
      }
    }
  },
  ".fr": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "FR Business Resources Pricing Form",
        CampaignID: "7010W000001zGtT",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "FR Business Webpage Pricing Form",
        CampaignID: "7010W0000023sKq",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "FR EDU Webpage Pricing Form",
        CampaignID: "7010W0000023sKv",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "FR HED Webpage Pricing Form",
        CampaignID: "7010W000002bHvE",
        subSector1: ""
      }
    }
  },
  ".br": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "BR Business Resources Pricing Form",
        CampaignID: "7010W000001zGtJ",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "BR Business Webpage Pricing Form",
        CampaignID: "7010W0000023sKl",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "BR EDU Webpage Pricing Form",
        CampaignID: "7010W0000023sKg",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "BR HED Webpage Pricing Form",
        CampaignID: "7010W000002bHv4",
        subSector1: ""
      }
    }
  },
  ".it": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "IT Business Resources Pricing Form",
        CampaignID: "7010W000001zGtd",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "IT Business Webpage Pricing Form",
        CampaignID: "7010W000001zG3w",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "IT EDU Webpage Pricing Form",
        CampaignID: "7010W000001zG41",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "IT HED Webpage Pricing Form",
        CampaignID: "7010W000001zG4B",
        subSector1: ""
      }
    }
  },
  ".cn": {
    business: {
      resources: {
        omniformname: "corporate",
        importSourceMostRecent1: "CN Business Resources Pricing Form",
        CampaignID: "7010W000001v54I",
        subSector1: ""
      },
      webpage: {
        omniformname: "corporate",
        importSourceMostRecent1: "CN Business Webpage Pricing Form",
        CampaignID: "7010W000001v543",
        subSector1: ""
      }
    },
    k12: {
      webpage: {
        omniformname: "k12",
        importSourceMostRecent1: "CN EDU Webpage Pricing Form",
        CampaignID: "7010W000001v53j",
        subSector1: ""
      }
    },
    hed: {
      webpage: {
        omniformname: "hed",
        importSourceMostRecent1: "CN HED Webpage Pricing Form",
        CampaignID: "7010W000001v548",
        subSector1: ""
      }
    }
  }
};

var leadGenerationConstants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  storeRoot: storeRoot$2,
  submissionStatus: submissionStatus,
  formConditions: formConditions
});

var sendLeadGenerationData$1 = function sendLeadGenerationData(payload) {
  // Data Cleanup
  // This refers to react state, not geolocation state.
  // geolocation state can be found at state_code
  delete payload.state;
  delete payload.key; // Endpoint API value is set in the env files at the root of the hub.

  return fetch(process.env.RS_API_LEAD_GENERATION, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "omit",
    headers: {
      "Content-Type": "application/json"
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: JSON.stringify(payload)
  }).then(function (response) {
    return response.text();
  }).then(function (responseJson) {
    return responseJson;
  });
};
var fireGTMCustomEvents = function fireGTMCustomEvents(payload) {
  if (typeof window !== "undefined") {
    // Define dataLayer if it does not exist already
    window.dataLayer = window.dataLayer || []; // Fire "b2bRequest" on all instances (Used by EMEA GTM container)

    window.dataLayer.push({
      event: "b2bRequest"
    }); // Fire "b2bRequest:soi" only when visitor opts in to marketing (Used by EMEA GTM container)

    if (payload && payload.explicitOptIn && payload.explicitOptIn === true) {
      window.dataLayer.push({
        event: "b2bRequest:soi"
      });
    } // Fire either Enterprise or Education conversion custom GTM event


    if (payload && payload.vertical && /^enterprise/i.test(payload.vertical)) {
      window.dataLayer.push({
        event: "enterpriseLeadSuccess",
        eneLeadFormData: payload
      });
    } else if (payload && payload.vertical && /^education/i.test(payload.vertical)) {
      window.dataLayer.push({
        event: "educationLeadSuccess",
        eneLeadFormData: payload
      });
    }
  }
}; // Deprecate Below When Direct Eloqua Communication is no longer needed

var querySchemaLowerCase = {
  elqformname: "elqFormName",
  elqsiteid: "elqSiteId",
  elqcampaignid: "elqCampaignId",
  first_name: "first_name",
  last_name: "last_name",
  company: "company",
  email: "email",
  title: "title",
  role: "role",
  phone: "phone",
  country: "country",
  state: "state",
  mobile: "mobile",
  querystring: "querystring",
  channel: "channel",
  importsourcemostrecent1: "importSourceMostRecent1",
  leadsourcemostrecent1: "leadSourceMostRecent1",
  leadvehicle: "leadVehicle",
  mqlflag: "MQLFlag",
  assettype: "assetType",
  emailassetcode: "EmailAssetCode",
  redirectcode: "RedirectCode",
  industry: "Industry",
  campaignid: "CampaignID",
  landingpageurl: "LandingPageURL",
  sfdclastcampaignstatus: "sFDCLastCampaignStatus",
  url: "url",
  emailname: "emailName",
  guid1: "gUID1",
  numberattending: "numberattending",
  namescoming: "namescoming",
  anythingtoadd: "anythingtoadd",
  buyingjourney1: "buyingJourney1",
  institutionsize1: "institutionSize1",
  lastaccessedassetid1: "lastAccessedAssetID1",
  explicitoptin: "ExplicitOptIn",
  gclid: "gclid",
  howdidyouhearaboutus1: "howDidYouHearAboutUs1"
};
var getUrlParams = function getUrlParams() {
  var search = window.location.search;
  var hashes = search.slice(search.indexOf("?") + 1).split("&"); // if values, construct an object out of them

  if (hashes[0]) {
    return hashes.reduce(function (params, hash) {
      var split = hash.indexOf("=");
      var key = hash.slice(0, split).toLowerCase();
      var val = hash.slice(split + 1); // ensure param is in schema

      if (key in querySchemaLowerCase) {
        return Object.assign(params, _defineProperty({}, querySchemaLowerCase[key], decodeURIComponent(val)));
      }

      return params;
    }, {});
  }

  return {}; // default to empty object
};
/**
 * Formats vertical as either "K-12" or "Corporate" for use in industry"
 * @param {bool} ExplicitOptIn
 */

/**
 * Converts ExplicitOptIn bool to either "on" or "off"
 * @param {bool} ExplicitOptIn
 */

var deriveExplicitOptIn = function deriveExplicitOptIn(ExplicitOptIn) {
  return ExplicitOptIn ? "on" : "off";
};
/**
 * Tries to return the url of the current page
 */


var populateLandingPageURL = function populateLandingPageURL() {
  return typeof window !== "undefined" ? window.location.href : "";
};
/**
 * Performs some conversions/formatting, and additions to the formdata.
 * [Industry, ExplicitOptIn, LandingPageURL]
 * @param {string} vertical
 * @param {Object} formData all the other form data
 */


var deriveSubmitData = function deriveSubmitData(vertical, formData) {
  return _objectSpread2(_objectSpread2({}, formData), {}, {
    ExplicitOptIn: deriveExplicitOptIn(formData.ExplicitOptIn),
    LandingPageURL: populateLandingPageURL()
  });
};
/**
 * Converts JS object to URL form submission url
 * @param {Object} submitData data to be submitted
 */

var constructSubmitUrl = function constructSubmitUrl(submitData) {
  var baseUrl = "https://s1294.t.eloqua.com/e/f2?";
  var params = Object.keys(submitData).map(function (key) {
    return "".concat(key, "=").concat(encodeURIComponent(submitData[key]));
  });
  return baseUrl + params.join("&");
};
/**
 * Submits email to Bizible. Adapted from Bizible's documentaiton on "AJAX Form
 * Handling"
 * @param {string} email user email
 */

var submitToBizible = function submitToBizible(email) {
  // Preamble for all API usage.

  /* eslint-disable no-underscore-dangle */
  window.Bizible = window.Bizible || {
    _queue: [],
    Push: function Push(o, p) {
      this._queue.push({
        type: o,
        data: p
      });
    }
  };
  /* eslint-enable no-underscore-dangle */
  // If your site is using Ajax, or you are running a secure site, it is best to send us the data directly.

  window.Bizible.Push("User", {
    eMail: email // required

  });
}; // TODO FIXME XXX This results in a bunch of iFrames added to the dom, try again with AJAX.

var submitWithIframe = function submitWithIframe(postUrl) {
  var iframe = document.createElement("iframe");

  var onReady = function onReady() {
    iframe.remove();
  };

  iframe.className = "background-submit";
  iframe.style.display = "none";
  iframe.src = postUrl;
  iframe.onreadystatechange = onReady();
  iframe.onload = onReady();
  document.body.append(iframe);
};
/**
 * Keeps any truthy values in the starter object and fills any falsy values in
 * starter with the values of filler.
 * @param {Object} starter
 * @param {Object} filler
 */

var conditionallyAssign = function conditionallyAssign(starter, filler) {
  var obj = _objectSpread2({}, starter);

  Object.entries(filler).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (!starter[key]) obj[key] = value;
  });
  return obj;
};

var replaceUndefined = function replaceUndefined(starter) {
  var obj = _objectSpread2({}, starter);

  Object.keys(obj).forEach(function (key) {
    if (!starter[key]) obj[key] = "";
  });
  return obj;
};
/**
 *
 * @param {Object} argsForDerivation
 * @param {string} argsForDerivation.domain
 * @param {string} argsForDerivation.vertical
 * @param {string} argsForDerivation.page
 */


var deriveHardcodedFormData = function deriveHardcodedFormData(argsForDerivation) {
  var domain = argsForDerivation.domain,
      vertical = argsForDerivation.vertical,
      page = argsForDerivation.page;
  var formVertical = vertical; //  TODO: REMOVE THIS ASAP
  //  This is terrible and temporary.  formConditions should be deprecated and moved to the config project.

  if (vertical === "enterprise") {
    formVertical = "business";
  }

  if (vertical === "education-primary") {
    formVertical = "k12";
  }

  if (vertical === "education-secondary") {
    formVertical = "hed";
  }

  try {
    var formValues = formConditions[domain][formVertical][page];
    return _objectSpread2({}, formValues);
  } catch (err) {
    console.warn("Unable to derive hardcoded form data, using US business as a fallback\n", err);
    return {
      omniformname: "corporate",
      importSourceMostRecent1: "US Business Resources Pricing Form",
      CampaignID: "7010W000002b4xX",
      subSector1: ""
    };
  }
};
/**
 * Values for these fields can be fed in as hardcoded props where the GateForm
 * is defined. This method processes those props and adds them to the store. In
 * cases of overlap of importSourceMostRecent1, the direct values take
 * precedent.
 * @param vertical
 */

var setIndustry = function setIndustry(vertical) {
  switch (vertical) {
    case "education-primary":
    case "k12":
      return "K-12";

    case "education-secondary":
    case "hed":
      return "Higher Education";

    case "pubsec":
      return "Public Sector";

    default:
      return "Corporate";
  }
};

var processHardcodedFormData = function processHardcodedFormData(argsForDerivation, directValues) {
  var derivedValues = deriveHardcodedFormData(argsForDerivation);

  var starter = _objectSpread2({}, replaceUndefined(directValues));

  var filler = {
    importSourceMostRecent1: derivedValues.importSourceMostRecent1,
    omniformname: derivedValues.omniformname,
    CampaignID: derivedValues.CampaignID,
    subSector1: derivedValues.subSector1,
    Industry: setIndustry(argsForDerivation.vertical)
  };
  return conditionallyAssign(starter, filler);
};
var options = {
  EloquaSiteID: "1294",
  EloquaScript: "//img.en25.com/i/elqCfg.min.js",
  LookupIdVisitor: "82fb0c8fa2c341ac915afd1f6b4e2702",
  LookupIdPrimary: "ddbbcf3eff0a4852979ca8d2f22d3770",
  VisitorUniqueField: "V_ElqEmailAddress",
  PrimaryUniqueField: "C_EmailAddress",
  EloquaFormID: "2016-Master-Form-Campaign"
};
/* eslint-disable no-undef */

var setFormValues = function setFormValues() {
  return {
    first_name: GetElqContentPersonalizationValue("C_FirstName"),
    last_name: GetElqContentPersonalizationValue("C_LastName"),
    email: GetElqContentPersonalizationValue("C_EmailAddress"),
    company: GetElqContentPersonalizationValue("C_Company"),
    role: GetElqContentPersonalizationValue("C_Role1"),
    country: GetElqContentPersonalizationValue("C_Country"),
    phone: GetElqContentPersonalizationValue("C_BusPhone"),
    institutionSize1: GetElqContentPersonalizationValue("C_Institution_Size1"),
    howDidYouHearAboutUs1: GetElqContentPersonalizationValue("C_howDidYouHearAboutUs1")
  };
};
/* eslint-enable no-undef */
// TODO FIXME XXX This appends a couple scripts to the dom everytime it's executed. Need a cleaner solution => move pre-pop data to global store.

/**
 * Tries to perform am Eloqua lookup using the Eloqua cookie. If successful it will pre-populate the form with the looked up values.
 * Adapted from http://mediarolls.com/DLPrepop/DLPrepop.html
 *
 * @returns {Promise} Promise that resolves to object of pre-pop values
 */


var prePopulateEloquaData = function prePopulateEloquaData() {
  return new Promise(function (resolve, reject) {
    /* eslint-disable no-underscore-dangle */
    var onReady = function onReady() {
      // try to reference the _elqQ object that gets loaded into the global namespace
      var _window = window,
          _elqQ = _window._elqQ;

      if (!_elqQ) {
        var err = "There was an issue communicating with Eloqua"; // TODO Log errors console.warn(err);

        reject(err);
      }

      _elqQ.push(["elqSetSiteId", options.EloquaSiteID]);

      _elqQ.push(["elqTrackPageView"]); // LOOKUP A:  Eloqua Visitor Data Lookup from Cookie  -  Ensure VisitorUniqueField is pulled in the Profile View


      _elqQ.push(["elqDataLookup", escape(options.LookupIdVisitor), ""]);
    };
    /* eslint-enable no-underscore-dangle */
    // load the eloqua script then begin calling functions that rely on it


    var async_load = function async_load() {
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = options.EloquaScript;

      s.onreadystatechange = function () {
        return onReady();
      };

      s.onload = function () {
        return onReady();
      };

      var x = document.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
    };

    async_load();
    var FirstLookup = true; // expose to global namespace so Eloqua can call it

    window.SetElqContent = function () {
      /* eslint-disable no-underscore-dangle */
      if (FirstLookup) {
        // LOOKUP B:  Eloqua Contact/DataCard/Prospect/Company Data Lookup from Email Address
        window._elqQ.push(["elqDataLookup", escape(options.LookupIdPrimary),
        /* eslint-disable no-undef */
        "\n                        <".concat(options.PrimaryUniqueField, ">\n                        ").concat(GetElqContentPersonalizationValue(options.VisitorUniqueField), "\n                        </").concat(options.PrimaryUniqueField, ">\n                    ")
        /* eslint-enable no-undef */
        ]);

        FirstLookup = false;
      } else {
        // This is triggered the after Lookup B fires.  LoadFields starts the field prepoulation process.
        var formValues = setFormValues();
        resolve(formValues);
      }
      /* eslint-enable no-underscore-dangle */

    };
  });
};
var submitToApi = function submitToApi(data) {
  // Endpoint API value is set in the env files at the root of the hub.
  return fetch(process.env.RS_API_LEAD_GENERATION, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "omit",
    headers: {
      "Content-Type": "application/json"
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: JSON.stringify(data)
  }).then(function (response) {
    return response.text();
  }).then(function (responseJson) {
    return responseJson;
  });
};

var initialState = {
  submission: null,
  response: null,
  status: submissionStatus$1.open,
  errors: null,
  schedule_appointment: false,
  appointment: null,
  completion_redirect: null // Deprecate below
  // "form-test": "Experience C-Pricing",
  // anythingtoadd: "",
  // anythingtoadd_error: false,
  // assetType: "",
  // CampaignID: "7010W000002b4xX",
  // company: "",
  // company_error: false,
  // country: "",
  // country_error: false,
  // elqFormName: "2016-Master-Form-Campaign",
  // elqSiteID: "1294",
  // email: "",
  // email_error: false,
  // EmailAssetCode: "",
  // ExplicitOptIn: false,
  // first_name: "",
  // first_name_error: false,
  // formSubmitted: false,
  // howDidYouHearAboutUs1: "",
  // howDidYouHearAboutUs1_error: false,
  // importSourceMostRecent1: "US Business Resources Pricing Form",
  // Industry: "",
  // institutionSize1: "",
  // institutionSize1_error: false,
  // isFormValid: false,
  // LandingPageURL: "",
  // last_name: "",
  // last_name_error: false,
  // lastAccessedAssetID1: "",
  // leadSourceMostRecent1: "Collateral Request",
  // leadVehicle: "Search - Organic",
  // omniformname: "corporate",
  // phone: "",
  // phone_error: false,
  // productSolutionOfInterest1: "",
  // productSolutionOfInterest1_error: false,
  // role: "",
  // role_error: false,
  // state: "",
  // subSector1: ""

};
var leadGenerationReducer = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case LEAD_GENERATION_SUBMISSION:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        submission: action.payload
      });

    case LEAD_GENERATION_RESPONSE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        response: action.payload
      });

    case LEAD_GENERATION_SET_COMPLETION_REDIRECT:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        completion_redirect: action.payload
      });

    case LEAD_GENERATION_SET_SCHEDULE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        schedule_appointment: action.payload
      });

    case LEAD_GENERATION_SET_APPOINTMENT:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        appointment: action.payload
      });

    case LEAD_GENERATION_STATUS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        status: action.payload
      });

    case LEAD_GENERATION_CLEAR:
      return initialState;
    // Deprecate Below When Direct Eloqua Communication is no longer needed

    case USER_SUBMIT_FORM:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        formSubmitted: true
      });

    case AUTO_SUBMIT_FORM:
      return _objectSpread2(_objectSpread2({}, state), action.submitData);

    case PROCESS_FIELD_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, "".concat(action.fieldName, "_error"), action.validity));

    case VERIFY_FORM_VALIDITY:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isFormValid: action.validity
      });

    case FORM_FIELD_CHANGE:
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.name, action.value));

    case ELOQUA_PREPOP_SUCCESS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        eloqua: conditionallyAssign(state, action.response)
      });

    case PROCESS_HARDCODED_FORM_DATA:
      return _objectSpread2(_objectSpread2({}, state), action.hardcodedValues);

    case PARSE_QUERY_PARAMS:
      return _objectSpread2(_objectSpread2(_objectSpread2({}, state), action.params), {}, {
        querystring: action.querystring
      });

    case GEOIP_SUCCESS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        country: action.response.country,
        state: action.response.state
      });

    case GEOIP_FALLBACK:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        country: action.response.country
      });

    default:
      return state;
  }
});

var actionTypes$1 = {
  OVERLAY_SET_ACTIVE: "OVERLAY_SET_ACTIVE",
  OVERLAY_CLEAR: "OVERLAY_CLEAR"
};

var initialFormData = {
  active: null
};

var emailCollectionFormReducers = function emailCollectionFormReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialFormData;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes$1.OVERLAY_CLEAR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        active: null
      });

    case actionTypes$1.OVERLAY_SET_ACTIVE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        active: action.payload
      });

    default:
      return state;
  }
};

var storeRoot$1 = "overlay";

var actionTypes = {
  SET_CART_IFRAME_URL: "SET_CART_IFRAME_URL",
  SET_SHOW_LOADING_MESSAGES: "SET_SHOW_LOADING_MESSAGES",
  SET_IS_CART_VISIBLE: "SET_IS_CART_VISIBLE",
  SET_IS_OVERLAY_VISIBLE: "SET_IS_OVERLAY_VISIBLE"
};

var initialCartData = {
  cartIframeUrl: "",
  showLoadingMessages: true,
  isCartVisible: false,
  isOverlayVisible: true
};

var cartReducers = function cartReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialCartData;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes.SET_CART_IFRAME_URL:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        cartIframeUrl: action.payload
      });

    case actionTypes.SET_SHOW_LOADING_MESSAGES:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        showLoadingMessages: action.payload
      });

    case actionTypes.SET_IS_CART_VISIBLE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isCartVisible: action.payload
      });

    case actionTypes.SET_IS_OVERLAY_VISIBLE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isOverlayVisible: action.payload
      });

    default:
      return state;
  }
};

var storeRoot = "cart";

var cartConstants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  storeRoot: storeRoot
});

var _combineReducers;
var rootReducer = combineReducers((_combineReducers = {}, _defineProperty(_combineReducers, storeRoot$3, emailCollectionFormReducers$1), _defineProperty(_combineReducers, storeRoot$2, leadGenerationReducer), _defineProperty(_combineReducers, storeRoot$1, emailCollectionFormReducers), _defineProperty(_combineReducers, storeRoot, cartReducers), _combineReducers));

var setEmailCollectionSubmission = function setEmailCollectionSubmission(submission) {
  return {
    type: actionTypes$2.EMAIL_COLLECTION_SUBMISSION,
    payload: submission
  };
};
var setEmailCollectionResponse = function setEmailCollectionResponse(response) {
  return {
    type: actionTypes$2.EMAIL_COLLECTION_RESPONSE,
    payload: response
  };
};
var setEmailCollectionStatus = function setEmailCollectionStatus(status) {
  return {
    type: actionTypes$2.EMAIL_COLLECTION_STATUS,
    payload: status
  };
};

var emailCollectionActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setEmailCollectionSubmission: setEmailCollectionSubmission,
  setEmailCollectionResponse: setEmailCollectionResponse,
  setEmailCollectionStatus: setEmailCollectionStatus
});

var getSubmissionStatus$1 = function getSubmissionStatus(state) {
  return state[storeRoot$3].status;
};
var getSubmissionData$1 = function getSubmissionData(state) {
  return state[storeRoot$3].submission;
};
var getResponseData$1 = function getResponseData(state) {
  return state[storeRoot$3].response;
};

var emailCollectionSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getSubmissionStatus: getSubmissionStatus$1,
  getSubmissionData: getSubmissionData$1,
  getResponseData: getResponseData$1
});

var fetchEmailCollection = function fetchEmailCollection(_ref) {
  var cid = _ref.cid,
      consentType = _ref.consentType,
      demo_type = _ref.demo_type,
      email = _ref.email,
      language = _ref.language,
      newsletter_type = _ref.newsletter_type,
      visitCountryCode = _ref.visitCountryCode,
      web_path = _ref.web_path,
      website = _ref.website;
  var data = {
    cid: cid,
    consentType: consentType,
    demoType: demo_type,
    emailAddress: email,
    emailNotify: 0,
    formUrl: web_path,
    newsletterType: newsletter_type,
    siteLang: language || "ENG",
    verifyEmail: true,
    visitCountryCode: visitCountryCode,
    website: website
  };

  if (data.consentType === "implicit") {
    data.emailNotify = 1;
  } // Endpoint API value is set in the env files at the root of the hub.


  return fetch(process.env.RS_API_WEBLEADS, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "omit",
    headers: {
      "Content-Type": "application/json"
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: JSON.stringify(data)
  }).then(function (response) {
    return response.text();
  }).then(function (responseJson) {
    return responseJson;
  });
};

var _marked$1 = /*#__PURE__*/regeneratorRuntime.mark(sendEmailCollectionData),
    _marked2$1 = /*#__PURE__*/regeneratorRuntime.mark(sagas$1);

function sendEmailCollectionData() {
  var data, processedData;
  return regeneratorRuntime.wrap(function sendEmailCollectionData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getSubmissionData$1);

        case 2:
          data = _context.sent;
          _context.next = 5;
          return put(setEmailCollectionStatus(submissionStatus$1.sent));

        case 5:
          _context.next = 7;
          return call(fetchEmailCollection, data);

        case 7:
          processedData = _context.sent;
          _context.next = 10;
          return put(setEmailCollectionResponse(JSON.parse(processedData)));

        case 10:
          _context.next = 12;
          return put(setEmailCollectionStatus(submissionStatus$1.received));

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$1);
}

function sagas$1() {
  return regeneratorRuntime.wrap(function sagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(actionTypes$2.EMAIL_COLLECTION_SUBMISSION, sendEmailCollectionData);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$1);
}

var setLeadGenerationSubmission = function setLeadGenerationSubmission(submission) {
  return {
    type: LEAD_GENERATION_SUBMISSION,
    payload: submission
  };
};
var setLeadGenerationResponse = function setLeadGenerationResponse(response) {
  return {
    type: LEAD_GENERATION_RESPONSE,
    payload: response
  };
};
var setLeadGenerationStatus = function setLeadGenerationStatus(status) {
  return {
    type: LEAD_GENERATION_STATUS,
    payload: status
  };
};
var setLeadGenerationScheduleAppointment = function setLeadGenerationScheduleAppointment(schedule) {
  return {
    type: LEAD_GENERATION_SET_SCHEDULE,
    payload: schedule
  };
};
var setLeadGenerationAppointment = function setLeadGenerationAppointment(appointment) {
  return {
    type: LEAD_GENERATION_SET_APPOINTMENT,
    payload: appointment
  };
};
var setLeadGenerationCompletionRedirect = function setLeadGenerationCompletionRedirect(destination) {
  return {
    type: LEAD_GENERATION_SET_COMPLETION_REDIRECT,
    payload: destination
  };
};
var setLeadGenerationClearForm = function setLeadGenerationClearForm() {
  return {
    type: LEAD_GENERATION_CLEAR
  };
}; // Deprecate Below When Direct Eloqua Communication is no longer needed

var eloquaDataRequest = function eloquaDataRequest() {
  return {
    type: ELOQUA_PREPOP_REQUEST
  };
};
var eloquaDataSuccess = function eloquaDataSuccess(eloquaData) {
  return {
    type: ELOQUA_PREPOP_SUCCESS,
    response: eloquaData
  };
};
var eloquaDataFailure = function eloquaDataFailure(errorObj) {
  return {
    type: ELOQUA_PREPOP_FAILURE,
    error: errorObj
  };
};
var prepareUserSubmitToEloqua = function prepareUserSubmitToEloqua(vertical) {
  return {
    type: PREPARE_USER_SUBMIT_FORM,
    vertical: vertical
  };
};
var sendUserSubmitToEloqua = function sendUserSubmitToEloqua(submitData) {
  return {
    type: USER_SUBMIT_FORM,
    submitData: submitData
  };
};
var prepareAutoSubmitToEloqua = function prepareAutoSubmitToEloqua(vertical) {
  return {
    type: PREPARE_AUTO_SUBMIT_FORM,
    vertical: vertical
  };
};
var sendAutoSubmitToEloqua = function sendAutoSubmitToEloqua(submitData) {
  return {
    type: AUTO_SUBMIT_FORM,
    submitData: submitData
  };
};
var changeFieldValue = function changeFieldValue(_ref) {
  var target = _ref.target;
  var name = target.name,
      type = target.type;
  var value = type === "checkbox" ? target.checked : target.value;
  return {
    type: FORM_FIELD_CHANGE,
    name: name,
    value: value
  };
};
var handleHardCodedFormData = function handleHardCodedFormData(argsForDerivation, directValues) {
  return {
    type: PROCESS_HARDCODED_FORM_DATA,
    hardcodedValues: processHardcodedFormData(argsForDerivation, directValues)
  };
};
var processFieldError = function processFieldError(fieldName, validity) {
  return {
    type: PROCESS_FIELD_ERROR,
    fieldName: fieldName,
    validity: validity
  };
};
var verifyFormValidity = function verifyFormValidity(validity) {
  return {
    type: VERIFY_FORM_VALIDITY,
    validity: validity
  };
};
var geoIpRequest = function geoIpRequest() {
  return {
    type: GEOIP_REQUEST
  };
};
var geoIpSuccess = function geoIpSuccess(locationData) {
  return {
    type: GEOIP_SUCCESS,
    response: locationData
  };
};
var geoIpFailure = function geoIpFailure(errorObj) {
  return {
    type: GEOIP_FAILURE,
    error: errorObj
  };
};
var geoIpFallback = function geoIpFallback(country) {
  return {
    type: GEOIP_FALLBACK,
    response: {
      country: country
    }
  };
};
var parseQueryParams = function parseQueryParams() {
  return {
    type: PARSE_QUERY_PARAMS,
    params: getUrlParams(),
    querystring: window.location.search
  };
};

var leadGenerationActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setLeadGenerationSubmission: setLeadGenerationSubmission,
  setLeadGenerationResponse: setLeadGenerationResponse,
  setLeadGenerationStatus: setLeadGenerationStatus,
  setLeadGenerationScheduleAppointment: setLeadGenerationScheduleAppointment,
  setLeadGenerationAppointment: setLeadGenerationAppointment,
  setLeadGenerationCompletionRedirect: setLeadGenerationCompletionRedirect,
  setLeadGenerationClearForm: setLeadGenerationClearForm,
  eloquaDataRequest: eloquaDataRequest,
  eloquaDataSuccess: eloquaDataSuccess,
  eloquaDataFailure: eloquaDataFailure,
  prepareUserSubmitToEloqua: prepareUserSubmitToEloqua,
  sendUserSubmitToEloqua: sendUserSubmitToEloqua,
  prepareAutoSubmitToEloqua: prepareAutoSubmitToEloqua,
  sendAutoSubmitToEloqua: sendAutoSubmitToEloqua,
  changeFieldValue: changeFieldValue,
  handleHardCodedFormData: handleHardCodedFormData,
  processFieldError: processFieldError,
  verifyFormValidity: verifyFormValidity,
  geoIpRequest: geoIpRequest,
  geoIpSuccess: geoIpSuccess,
  geoIpFailure: geoIpFailure,
  geoIpFallback: geoIpFallback,
  parseQueryParams: parseQueryParams
});

var getScheduleAppointment = function getScheduleAppointment(state) {
  return state[storeRoot$2].schedule_appointment;
};
var getCompletionRedirect = function getCompletionRedirect(state) {
  return state[storeRoot$2].completion_redirect;
};
var getSubmissionStatus = function getSubmissionStatus(state) {
  return state[storeRoot$2].status;
};
var getSubmissionData = function getSubmissionData(state) {
  return state[storeRoot$2].submission;
};
var getResponseData = function getResponseData(state) {
  return state[storeRoot$2].response;
}; // Deprecate Below When Direct Eloqua Communication is no longer needed

var getAllData = function getAllData(state) {
  return state[storeRoot$2];
};
var getFieldValue = function getFieldValue(state, field) {
  return state[storeRoot$2][field];
};

var leadGenerationSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getScheduleAppointment: getScheduleAppointment,
  getCompletionRedirect: getCompletionRedirect,
  getSubmissionStatus: getSubmissionStatus,
  getSubmissionData: getSubmissionData,
  getResponseData: getResponseData,
  getAllData: getAllData,
  getFieldValue: getFieldValue
});

var _marked = /*#__PURE__*/regeneratorRuntime.mark(sendLeadGenerationData),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(userSubmitToEloqua),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(autoSubmitToEloqua),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(fetchEloquaData),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(sagas);

function sendLeadGenerationData() {
  var formData, processedData;
  return regeneratorRuntime.wrap(function sendLeadGenerationData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getSubmissionData);

        case 2:
          formData = _context.sent;
          _context.next = 5;
          return put(setLeadGenerationStatus(submissionStatus.sent));

        case 5:
          _context.next = 7;
          return call(sendLeadGenerationData$1, formData);

        case 7:
          processedData = _context.sent;
          _context.next = 10;
          return put(setLeadGenerationResponse(processedData));

        case 10:
          _context.next = 12;
          return put(setLeadGenerationStatus(submissionStatus.received));

        case 12:
          _context.next = 14;
          return put(setLeadGenerationStatus(submissionStatus.success));

        case 14:
          _context.next = 16;
          return call(fireGTMCustomEvents, formData);

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
} // Deprecate Below When Direct Eloqua Communication is no longer needed


function userSubmitToEloqua(vertical) {
  var formData, submitData;
  return regeneratorRuntime.wrap(function userSubmitToEloqua$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(getAllData);

        case 2:
          formData = _context2.sent;
          _context2.next = 5;
          return call(submitToBizible, formData.email);

        case 5:
          _context2.next = 7;
          return call(deriveSubmitData, vertical, formData);

        case 7:
          submitData = _context2.sent;
          _context2.next = 10;
          return call(submitToApi, submitData);

        case 10:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function autoSubmitToEloqua(_ref) {
  var vertical, formData, submitData, postUrl;
  return regeneratorRuntime.wrap(function autoSubmitToEloqua$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          vertical = _ref.vertical;
          _context3.next = 3;
          return select(getAllData);

        case 3:
          formData = _context3.sent;
          _context3.next = 6;
          return call(deriveSubmitData, vertical, formData);

        case 6:
          submitData = _context3.sent;
          _context3.next = 9;
          return call(constructSubmitUrl, submitData);

        case 9:
          postUrl = _context3.sent;
          _context3.next = 12;
          return call(submitWithIframe, postUrl);

        case 12:
          _context3.next = 14;
          return put(sendUserSubmitToEloqua(submitData));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function fetchEloquaData() {
  var eloquaData;
  return regeneratorRuntime.wrap(function fetchEloquaData$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return call(prePopulateEloquaData);

        case 3:
          eloquaData = _context4.sent;
          _context4.next = 6;
          return put(eloquaDataSuccess(eloquaData));

        case 6:
          _context4.next = 12;
          break;

        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 12;
          return put(eloquaDataFailure(_context4.t0));

        case 12:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 8]]);
}

function sagas() {
  return regeneratorRuntime.wrap(function sagas$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return takeLatest(LEAD_GENERATION_SUBMISSION, sendLeadGenerationData);

        case 2:
          _context5.next = 4;
          return takeLatest(ELOQUA_PREPOP_REQUEST, fetchEloquaData);

        case 4:
          _context5.next = 6;
          return takeLatest(PREPARE_AUTO_SUBMIT_FORM, autoSubmitToEloqua);

        case 6:
          _context5.next = 8;
          return takeLatest(PREPARE_USER_SUBMIT_FORM, userSubmitToEloqua);

        case 8:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

var configureStore = (function (_ref) {
  var element = _ref.element;
  var sagaMiddleware = createSagaMiddleware();
  var store = createStore(rootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware))); // List Sagas

  sagaMiddleware.run(sagas$1);
  sagaMiddleware.run(sagas);
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, element);
});

var countryData = [{
  value: "China",
  label: "中国"
}, {
  value: "United States",
  label: "美国"
}, {
  value: "Canada",
  label: "加拿大"
}, {
  value: "Afghanistan",
  label: "阿富汗"
}, {
  value: "Albania",
  label: "阿尔巴尼亚"
}, {
  value: "Algeria",
  label: "阿尔及利亚"
}, {
  value: "Andorra",
  label: "安道尔"
}, {
  value: "Angola",
  label: "安哥拉"
}, {
  value: "Antigua and Barbuda",
  label: "安提瓜和巴布达"
}, {
  value: "Argentina",
  label: "阿根廷"
}, {
  value: "Armenia",
  label: "亚美尼亚"
}, {
  value: "Australia",
  label: "澳大利亚"
}, {
  value: "Austria",
  label: "奥地利"
}, {
  value: "Azerbaijan",
  label: "阿塞拜疆"
}, {
  value: "Bahamas",
  label: "巴哈马"
}, {
  value: "Bahrain",
  label: "巴林"
}, {
  value: "Bangladesh",
  label: "孟加拉国"
}, {
  value: "Barbados",
  label: "巴巴多斯"
}, {
  value: "Belarus",
  label: "白俄罗斯"
}, {
  value: "Belgium",
  label: "比利时"
}, {
  value: "Belize",
  label: "伯利兹"
}, {
  value: "Benin",
  label: "贝宁"
}, {
  value: "Bhutan",
  label: "不丹"
}, {
  value: "Bolivia",
  label: "玻利维亚"
}, {
  value: "Bosnia and Herzegovina",
  label: "波斯尼亚 – 黑塞哥维那"
}, {
  value: "Botswana",
  label: "博茨瓦纳"
}, {
  value: "Brazil",
  label: "巴西"
}, {
  value: "Brunei",
  label: "文莱达鲁萨兰国"
}, {
  value: "Bulgaria",
  label: "保加利亚"
}, {
  value: "Burkina Faso",
  label: "布基纳法索"
}, {
  value: "Burundi",
  label: "蒲隆地"
}, {
  value: "Cambodia",
  label: "柬埔寨"
}, {
  value: "Cameroon",
  label: "喀麦隆"
}, {
  value: "Cape Verde",
  label: "佛得角"
}, {
  value: "Chad",
  label: "乍得"
}, {
  value: "Chile",
  label: "智利"
}, {
  value: "Colombia",
  label: "哥伦比亚"
}, {
  value: "Democratic Republic of Congo",
  label: "刚果民主共和国"
}, {
  value: "Republic of Congo",
  label: "刚果共和国"
}, {
  value: "Costa Rica",
  label: "哥斯达黎加"
}, {
  value: "Ivory Coast",
  label: "科特迪瓦"
}, {
  value: "Croatia",
  label: "克罗地亚"
}, {
  value: "Cuba",
  label: "古巴"
}, {
  value: "Cyprus",
  label: "塞浦路斯"
}, {
  value: "Czechia",
  label: "捷克共和国"
}, {
  value: "Denmark",
  label: "丹麦"
}, {
  value: "Djibouti",
  label: "吉布提"
}, {
  value: "Dominica",
  label: "多米尼克"
}, {
  value: "Dominican Republic",
  label: "多米尼加共和国"
}, {
  value: "Ecuador",
  label: "厄瓜多尔"
}, {
  value: "Egypt",
  label: "埃及"
}, {
  value: "El Salvador",
  label: "萨尔瓦多"
}, {
  value: "Equatorial Guinea",
  label: "赤道几内亚"
}, {
  value: "Estonia",
  label: "爱沙尼亚"
}, {
  value: "Ethiopia",
  label: "埃塞俄比亚"
}, {
  value: "Fiji",
  label: "斐济"
}, {
  value: "Finland",
  label: "芬兰"
}, {
  value: "France",
  label: "法国"
}, {
  value: "Gabon",
  label: "加蓬"
}, {
  value: "Gambia",
  label: "冈比亚"
}, {
  value: "Georgia",
  label: "格鲁吉亚"
}, {
  value: "Germany",
  label: "德国"
}, {
  value: "Ghana",
  label: "加纳"
}, {
  value: "Greece",
  label: "希腊"
}, {
  value: "Grenada",
  label: "格林纳达"
}, {
  value: "Guatemala",
  label: "危地马拉"
}, {
  value: "Guinea",
  label: "几内亚"
}, {
  value: "Guinea Bissau",
  label: "几内亚比绍"
}, {
  value: "Guyana",
  label: "圭亚那"
}, {
  value: "Haiti",
  label: "海地"
}, {
  value: "Honduras",
  label: "洪都拉斯"
}, {
  value: "Hungary",
  label: "匈牙利"
}, {
  value: "Iceland",
  label: "冰岛"
}, {
  value: "India",
  label: "印度"
}, {
  value: "Indonesia",
  label: "印度尼西亚"
}, {
  value: "Iran",
  label: "伊朗"
}, {
  value: "Iraq",
  label: "伊拉克"
}, {
  value: "Ireland",
  label: "爱尔兰"
}, {
  value: "Israel",
  label: "以色列"
}, {
  value: "Italy",
  label: "意大利"
}, {
  value: "Jamaica",
  label: "牙买加"
}, {
  value: "Japan",
  label: "日本"
}, {
  value: "Jordan",
  label: "约旦"
}, {
  value: "Kazakhstan",
  label: "哈萨克斯坦"
}, {
  value: "Kenya",
  label: "肯尼亚"
}, {
  value: "Kuwait",
  label: "科威特"
}, {
  value: "Kyrgyzstan",
  label: "吉尔吉斯斯坦"
}, {
  value: "Laos",
  label: "老挝"
}, {
  value: "Latvia",
  label: "拉脱维亚"
}, {
  value: "Lebanon",
  label: "黎巴嫩"
}, {
  value: "Lesotho",
  label: "莱索托"
}, {
  value: "Liberia",
  label: "利比里亚"
}, {
  value: "Libya",
  label: "利比亚"
}, {
  value: "Liechtenstein",
  label: "列支敦士登"
}, {
  value: "Lithuania",
  label: "立陶宛"
}, {
  value: "Luxembourg",
  label: "卢森堡"
}, {
  value: "Macedonia",
  label: "马其顿"
}, {
  value: "Madagascar",
  label: "马达加斯加"
}, {
  value: "Malawi",
  label: "马拉维"
}, {
  value: "Malaysia",
  label: "马来西亚"
}, {
  value: "Maldives",
  label: "马尔代夫"
}, {
  value: "Mali",
  label: "马里"
}, {
  value: "Malta",
  label: "马耳他"
}, {
  value: "Mauritania",
  label: "毛里塔尼亚"
}, {
  value: "Mauritius",
  label: "毛里求斯"
}, {
  value: "Mexico",
  label: "墨西哥"
}, {
  value: "Moldova",
  label: "摩尔多瓦"
}, {
  value: "Monaco",
  label: "摩纳哥"
}, {
  value: "Mongolia",
  label: "蒙古"
}, {
  value: "Montenegro",
  label: "黑山"
}, {
  value: "Morocco",
  label: "摩洛哥"
}, {
  value: "Mozambique",
  label: "莫桑比克"
}, {
  value: "Namibia",
  label: "纳米比亚"
}, {
  value: "Nepal",
  label: "尼泊尔"
}, {
  value: "Netherlands",
  label: "荷兰"
}, {
  value: "New Zealand",
  label: "新西兰"
}, {
  value: "Nicaragua",
  label: "尼加拉瓜"
}, {
  value: "Niger",
  label: "尼日尔"
}, {
  value: "Nigeria",
  label: "尼日利亚"
}, {
  value: "Norway",
  label: "挪威"
}, {
  value: "Oman",
  label: "阿曼"
}, {
  value: "Pakistan",
  label: "巴基斯坦"
}, {
  value: "Palestine",
  label: "巴勒斯坦"
}, {
  value: "Panama",
  label: "巴拿马"
}, {
  value: "Papua New Guinea",
  label: "巴布亚新几内亚"
}, {
  value: "Paraguay",
  label: "巴拉圭"
}, {
  value: "Peru",
  label: "秘鲁"
}, {
  value: "Philippines",
  label: "菲律宾"
}, {
  value: "Poland",
  label: "波兰"
}, {
  value: "Portugal",
  label: "葡萄牙"
}, {
  value: "Qatar",
  label: "卡塔尔"
}, {
  value: "Romania",
  label: "罗马尼亚"
}, {
  value: "Russia",
  label: "俄罗斯"
}, {
  value: "Rwanda",
  label: "卢旺达"
}, {
  value: "Samoa",
  label: "萨摩亚"
}, {
  value: "San Marino",
  label: "圣马力诺"
}, {
  value: "Saudi Arabia",
  label: "沙特阿拉伯"
}, {
  value: "Senegal",
  label: "塞内加尔"
}, {
  value: "Serbia",
  label: "塞尔维亚"
}, {
  value: "Seychelles",
  label: "塞舌尔"
}, {
  value: "Sierra Leone",
  label: "塞拉利昂"
}, {
  value: "Singapore",
  label: "新加坡"
}, {
  value: "Slovakia",
  label: "斯洛伐克"
}, {
  value: "Slovenia",
  label: "斯洛文尼亚"
}, {
  value: "South Africa",
  label: "南非"
}, {
  value: "South Korea",
  label: "韩国"
}, {
  value: "South Sudan",
  label: "南蘇丹"
}, {
  value: "Spain",
  label: "西班牙"
}, {
  value: "Sri Lanka",
  label: "斯里兰卡"
}, {
  value: "St Kitts and Nevis",
  label: "圣基茨和尼维斯"
}, {
  value: "St Lucia",
  label: "圣卢西亚"
}, {
  value: "St Vincent and the Grenadines",
  label: "圣文森特和格林纳丁斯"
}, {
  value: "Sudan",
  label: "苏丹"
}, {
  value: "Suriname",
  label: "苏里南"
}, {
  value: "Swaziland",
  label: "史瓦济兰"
}, {
  value: "Sweden",
  label: "瑞典"
}, {
  value: "Switzerland",
  label: "瑞士"
}, {
  value: "Syria",
  label: "叙利亚"
}, {
  value: "Tajikistan",
  label: "塔吉克斯坦"
}, {
  value: "Tanzania",
  label: "坦桑尼亚"
}, {
  value: "Thailand",
  label: "泰国"
}, {
  value: "Togo",
  label: "多哥"
}, {
  value: "Tonga",
  label: "東加"
}, {
  value: "Trinidad and Tobago",
  label: "特立尼达和多巴哥"
}, {
  value: "Tunisia",
  label: "突尼斯"
}, {
  value: "Turkey",
  label: "土耳其"
}, {
  value: "Turkmenistan",
  label: "土库曼"
}, {
  value: "Tuvalu",
  label: "吐瓦鲁"
}, {
  value: "Uganda",
  label: "乌干达"
}, {
  value: "Ukraine",
  label: "乌克兰"
}, {
  value: "United Arab Emirates",
  label: "阿拉伯联合酋长国"
}, {
  value: "United Kingdom",
  label: "英国"
}, {
  value: "Uruguay",
  label: "乌拉圭"
}, {
  value: "Uzbekistan",
  label: "乌兹别克斯坦"
}, {
  value: "Venezuela",
  label: "委内瑞拉"
}, {
  value: "Vietnam",
  label: "越南"
}, {
  value: "Yemen",
  label: "也门"
}, {
  value: "Zambia",
  label: "赞比亚"
}, {
  value: "Zimbabwe",
  label: "津巴布韦"
}];

var businessData = {
  navTitle: "Navigate Hub",
  noDropDowns: [{
    title: "Customer Stories",
    url_slug: "case-studies-business"
  }],
  sections: [{
    title: "Business Need",
    sublevels: [{
      url_slug: "case-for-language-learning",
      title: "The Case for Language Learning"
    }, {
      url_slug: "customer-service",
      title: "Customer Service"
    }, {
      url_slug: "workforce-development",
      title: "Workforce Development"
    }, {
      url_slug: "productivity-collaboration",
      title: "Productivity & Collaboration"
    }, {
      url_slug: "workplace-safety",
      title: "Workplace Safety"
    }, {
      url_slug: "diversity-inclusion",
      title: "Diversity & Inclusion"
    }, {
      url_slug: "english-language-learning-2",
      title: "English Language Learning"
    }, {
      url_slug: "market-expansion",
      title: "Market Expansion"
    }]
  }, {
    title: "Resource Type",
    sublevels: [{
      url_slug: "bus-infographics",
      title: "Infographics"
    }, {
      url_slug: "white-papers-business",
      title: "Reports"
    }, {
      url_slug: "ebooks-corporate",
      title: "eBooks"
    }, {
      url_slug: "videos",
      title: "Videos"
    }, {
      url_slug: "webinars",
      title: "Webinars"
    }, {
      url_slug: "factsheet-business",
      title: "Fact Sheets"
    }]
  }]
};
var k12Data = {
  navTitle: "Navigate Hub",
  noDropDowns: [{
    title: "Customer Stories",
    url_slug: "customer-success-stories"
  }],
  sections: [{
    title: "Need",
    sublevels: [{
      url_slug: "world-language",
      title: "World Language"
    }, {
      url_slug: "english-language-learning",
      title: "English Language"
    }, {
      url_slug: "adult-education",
      title: "Adult Education"
    }]
  }, {
    title: "Implementation",
    sublevels: [{
      url_slug: "blended-learning",
      title: "Blended Learning"
    }, {
      url_slug: "online-learning",
      title: "Online Learning"
    }]
  }, {
    title: "Type",
    sublevels: [{
      url_slug: "infographics",
      title: "Infographics"
    }, {
      url_slug: "white-papers",
      title: "Reports"
    }, {
      url_slug: "ebooks",
      title: "eBooks"
    }, {
      url_slug: "video",
      title: "Videos"
    }, {
      url_slug: "k12-webinars",
      title: "Webinars"
    }, {
      url_slug: "podcasts",
      title: "Podcasts"
    }, {
      url_slug: "brochures",
      title: "Brochures"
    }, {
      url_slug: "teacher-resources",
      title: "Teacher Resources"
    }]
  }]
};
var serviceData = {
  navTitle: "Navigate Hub",
  sections: [{
    title: "Foundations",
    sublevels: [{
      title: "for Education"
    }, {
      url_slug: "getting-started-foundations-k12",
      title: "Getting Started"
    }, {
      url_slug: "administrator-tools-k12-found",
      title: "Administrator Tools"
    }, {
      url_slug: "administrator-resources-k12-found",
      title: "Administrator Resources"
    }, {
      url_slug: "learner-resources-k12-found",
      title: "Learner Resources"
    }, {
      title: "for Enterprise"
    }, {
      url_slug: "getting-started-ent-found",
      title: "Getting Started"
    }, {
      url_slug: "administrator-tools-ent-found",
      title: "Administrator Tools"
    }, {
      url_slug: "administrator-resources-ent-found",
      title: "Administrator Resources"
    }, {
      url_slug: "learner-resources-enterprise-foundations",
      title: "Learner Resources"
    }]
  }, {
    title: "Advantage",
    sublevels: [{
      title: "for Education"
    }, {
      url_slug: "getting-started-adv-edu",
      title: "Getting Started"
    }, {
      url_slug: "administrator-tools-adv-edu",
      title: "Administrator Tools"
    }, {
      url_slug: "administrator-resources-adv-edu",
      title: "Administrator Resources"
    }, {
      url_slug: "learner-resources-adv-edu",
      title: "Learner Resources"
    }, {
      title: "for Enterprise"
    }, {
      url_slug: "getting-started-rsa-ent",
      title: "Getting Started"
    }, {
      url_slug: "administrator-tools-rsa-ent",
      title: "Administrator Tools"
    }, {
      url_slug: "administrator-resources-rsa-ent",
      title: "Administrator Resources"
    }, {
      url_slug: "learner-resources-rsa-ent",
      title: "Learner Resources"
    }]
  }, {
    title: "Advanced",
    sublevels: [{
      url_slug: "getting-started-aeb",
      title: "Getting Started"
    }, {
      url_slug: "administrator-tools-aeb",
      title: "Administrator Tools"
    }, {
      url_slug: "administrator-resources-aeb",
      title: "Administrator Resources"
    }, {
      url_slug: "learner-resources-aeb",
      title: "Learner Resources"
    }]
  }, {
    title: "Catalyst",
    sublevels: [{
      url_slug: "getting-started-catalyst",
      title: "Getting Started"
    }, {
      url_slug: "administrator-tools-catalyst",
      title: "Administrator Tools"
    }, {
      url_slug: "administrator-resources-catalyst",
      title: "Administrator Resources"
    }, {
      url_slug: "learner-resources-catalyst",
      title: "Learner Resources"
    }]
  } // {
  //   title: 'Team Edition',
  //   sublevels: [
  //     {
  //       url_slug: 'getting-started-team-edition',
  //       title: 'Getting Started',
  //     },
  //     {
  //       url_slug: 'administrator-tools-team-edition',
  //       title: 'Administrator Tools',
  //     },
  //     {
  //       url_slug: 'administrator-resources-team-edition',
  //       title: 'Administrator Resources',
  //     },
  //     {
  //       url_slug: 'learner-resources-team-edition',
  //       title: 'Learner Resources',
  //     },
  //   ],
  // },
  ]
};
var deBusinessData = {
  navTitle: "Hub Navigieren",
  noDropDowns: [{
    title: "Bildung",
    url_slug: "bildungsressourcen"
  }, {
    title: "Unternehmen",
    url_slug: "geschaeftsressourcen"
  }],
  sections: []
};
var deServicesData = {
  navTitle: "Hub Navigieren",
  noDropDowns: [],
  sections: [{
    title: "Produkte",
    sublevels: [{
      title: "Catalyst",
      url_slug: "catalyst"
    }, {
      title: "Rosetta Stone AEB",
      url_slug: "rosetta-stone-aeb"
    }, {
      title: "Rosetta Stone V3",
      url_slug: "v3"
    }, {
      title: "Advantage",
      url_slug: "advantage"
    }, {
      title: "Foundaitons",
      url_slug: "foundations"
    }]
  }, {
    title: "Type",
    sublevels: [{
      title: "Videos: Catalyst",
      url_slug: "catalyst-videos"
    } // {
    //   title: 'Course #4: Get Ready',
    //   url_slug: 'ent-get-ready',
    // },
    // {
    //   title: 'Course #5: Learn Your Resources',
    //   url_slug: 'ent-learn-your-resources',
    // },
    // {
    //   title: 'Course #6: Ready, Set, Learn!',
    //   url_slug: 'edu-ready-set-learn',
    // },
    // {
    //   title: 'Course #7: Progress Checkpoint',
    //   url_slug: 'ent-progress-checkpoint',
    // },
    ]
  }]
};
var ukBusinessData = {
  navTitle: "Navigate Hub",
  sections: [{
    title: "Sector",
    sublevels: [{
      url_slug: "business",
      title: "Business"
    }, {
      url_slug: "education",
      title: "Education"
    }]
  }, {
    title: "Resource Type",
    sublevels: [{
      url_slug: "videos-webinars",
      title: "Videos and Webinars"
    }, {
      url_slug: "infographics",
      title: "Infographics"
    }, {
      url_slug: "reports-ebooks",
      title: "eBooks"
    }, {
      url_slug: "fact-sheets",
      title: "Fact Sheets"
    }]
  }],
  noDropDowns: [{
    url_slug: "customer-stories",
    title: "Customer Stories"
  }]
};
var laBusinessData = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};
var esBusinessData = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};
var esK12Data = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};
var esHEDData = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};
var frBusinessData = {
  navTitle: "",
  noDropDowns: [],
  sections: []
};
var brBusinessData = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};
var itBusinessData = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};
var cnBusinessData = {
  navTitle: "",
  sections: [],
  noDropDowns: []
};

var filterData = /*#__PURE__*/Object.freeze({
  __proto__: null,
  businessData: businessData,
  k12Data: k12Data,
  serviceData: serviceData,
  deBusinessData: deBusinessData,
  deServicesData: deServicesData,
  ukBusinessData: ukBusinessData,
  laBusinessData: laBusinessData,
  esBusinessData: esBusinessData,
  esK12Data: esK12Data,
  esHEDData: esHEDData,
  frBusinessData: frBusinessData,
  brBusinessData: brBusinessData,
  itBusinessData: itBusinessData,
  cnBusinessData: cnBusinessData
});

var setCartIframeUrl = function setCartIframeUrl(iframeUrl) {
  return {
    type: actionTypes.SET_CART_IFRAME_URL,
    payload: iframeUrl
  };
};
var setShowLoadingMessages = function setShowLoadingMessages(showLoadingMessages) {
  return {
    type: actionTypes.SET_SHOW_LOADING_MESSAGES,
    payload: showLoadingMessages
  };
};
var setIsCartVisible = function setIsCartVisible(isCartVisible) {
  return {
    type: actionTypes.SET_IS_CART_VISIBLE,
    payload: isCartVisible
  };
};
var setIsOverlayVisible = function setIsOverlayVisible(isOverlayVisible) {
  return {
    type: actionTypes.SET_IS_OVERLAY_VISIBLE,
    payload: isOverlayVisible
  };
};

var cartActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setCartIframeUrl: setCartIframeUrl,
  setShowLoadingMessages: setShowLoadingMessages,
  setIsCartVisible: setIsCartVisible,
  setIsOverlayVisible: setIsOverlayVisible
});

var getCartState = function getCartState(state) {
  return state[storeRoot];
};

var cartSelectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCartState: getCartState
});

var searchQueries = function searchQueries(_ref) {
  var hubId = _ref.hubId,
      market = _ref.market,
      indexName = _ref.indexName;
  return [{
    query: "query {\n          items: allAirtable(\n            filter: {\n              table: { eq: \"Items\" }\n              data: { \n                hubs: { eq: \"".concat(hubId, "\" }\n                market: { eq: \"").concat(market, "\" }\n              }\n            }\n          ) {\n            edges {\n              node {\n                id\n                data {\n                  title\n                  thumbnail_url\n                  thumbnail_alt_text\n                  description\n                  url_slug\n                  asset_type\n                  streams\n                }\n              }\n            }\n          }\n        }"),
    transformer: function transformer(_ref2) {
      var data = _ref2.data;
      return data.items.edges.map(function (_ref3) {
        var node = _ref3.node;
        return node;
      });
    },
    // optional
    indexName: indexName // overrides main index name, optional

  }];
};

var algoliaSearchQueries = /*#__PURE__*/Object.freeze({
  __proto__: null,
  searchQueries: searchQueries
});

// Store
var sampleData = {};
var staticData = {
  countryData: countryData,
  filterData: filterData
}; // Store

var leadGenerationStore = {
  leadGenerationActions: leadGenerationActions,
  leadGenerationConstants: leadGenerationConstants,
  leadGenerationSelectors: leadGenerationSelectors
};
var emailCollectionStore = {
  emailCollectionActions: emailCollectionActions,
  emailCollectionSelectors: emailCollectionSelectors,
  emailCollectionConstants: emailCollectionConstants
};
var cartStore = {
  cartActions: cartActions,
  cartSelectors: cartSelectors,
  cartConstants: cartConstants
};
var graphQl = {
  algolia: {
    queries: algoliaSearchQueries
  }
};
var store = {
  rootReducer: rootReducer,
  configureStore: configureStore
};

export { cartStore, emailCollectionStore, graphQl, leadGenerationStore, sampleData, staticData, store };
